import React from 'react';
import pt from 'prop-types';
import { MrInputMultiSelect } from '@ion/components';
import { Alert, Box } from '@metarouter-private/mr-mui';
import { useConsentCategoriesContext } from 'app/context/consent-categories-context';
import parseConsentCodes from 'app/components/analytics-builder/parseConsentCodes';
import validateConsentCodesSelected from './validateConsentCodesSelected';
import { CONSENT_GPC_CODES } from 'app/components/analytics-builder/form-keys';

export default function GpcCodesMultiSelect({ formState, setField }) {
  const { consentCategories } = useConsentCategoriesContext();
  const options = consentCategories.map(category => ({
    label: `${category.name} (${category.code})`,
    value: category.code,
  }));
  const selectedCodes = parseConsentCodes(formState[CONSENT_GPC_CODES]?.value);
  const defaultValue = options.filter(option => selectedCodes.includes(option.value));

  return (
    // MrInputMultiSelect carries no bottom margin of its own, unlike the other
    // Mr inputs — without this the next field's label crowds the helper text.
    <Box mb={3}>
      <MrInputMultiSelect
        onChange={setField}
        defaultValue={defaultValue}
        name={CONSENT_GPC_CODES}
        label="Global Privacy Control Codes"
        helperText="Consent codes forced to opted-out when a browser Global Privacy Control signal is detected."
        options={options}
        // NOTE: alphabetized={false} is load-bearing, not cosmetic —
        // transformOptions expects grouped options and would destructure a
        // nested `options` key off each flat entry if it ran.
        optionName="consent code"
        alphabetized={false}
        // Enabling GPC without codes builds a config that does nothing, so the
        // selection is required. validateRequired cannot see it — the hidden
        // input serializes an empty selection to '[]', which passes a
        // trim-length check.
        validators={[validateConsentCodesSelected()]}
        errorMsg={formState[CONSENT_GPC_CODES]?.errorMsg}
        required
      />
      {options.length === 0 && (
        <Alert severity="warning">
          Your organization has no consent categories, so Global Privacy Control has nothing to act on. An Integration
          Manager or Super Admin can create them.
        </Alert>
      )}
    </Box>
  );
}

GpcCodesMultiSelect.propTypes = {
  formState: pt.object.isRequired,
  setField: pt.func.isRequired,
};
